// extracted by mini-css-extract-plugin
module.exports = {"headerSty":"header_headerSty__VPRVa","itemText":"header_itemText__Cg86_"};